import assess from '@/pages/usedexcavator/index.vue';
const usedexcavator = [{
        path: '/usedexcavator/assess',
        // redirect: '/qiwei/mianqian',
        name: 'assess',
        component: assess,
        meta: {
            title: '二手机评估'
        }
    },

];


export default usedexcavator;


// WEBPACK FOOTER //
// ./src/router/modules/usedexcavator.js